// extracted by mini-css-extract-plugin
module.exports = {"buttons":"ConfirmModal_buttons__3R2ZZ","alertIcon":"ConfirmModal_alertIcon__3jXeY"};